import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../../shared/constants/constants";
import { useCustomAxios } from "../../shared/lib/customAxios";

export const searchProducts = createAsyncThunk(
    'product/search',
    async (queryParams: any) => {
        const { axiosGet } = useCustomAxios();
        try {
            let url = API_ENDPOINTS.searchProducts;
            Object.entries(queryParams).forEach(
                ([key, value], index) =>
                    (url = url + `${index > 0 ? '&' : '?'}${key}=${value}`)
            );
            const response = await axiosGet(url);

            return { data: response.data, status: response.status };
        } catch (error: any) {
            return {
                error: error.response.data.message,
                status: error.response.status,
            };
        }
    }
)

export const getProductById = createAsyncThunk(
    'product/getById',
    async (productId: any) => {
        const { axiosGet } = useCustomAxios();
        try {
            let url = API_ENDPOINTS.getProductById;
            url = url.replace(":productId", productId);
            const response = await axiosGet(url);

            return { data: response.data, status: response.status };
        } catch (error: any) {
            return {
                error: error.response.data.message,
                status: error.response.status,
            };
        }
    }
)

export const mergeProducts = createAsyncThunk(
  "product/merge",
  async (reqBody: any, { rejectWithValue }) => {
    const { axiosPost } = useCustomAxios();
    const url = `${API_ENDPOINTS.mergeProducts}`;
    try {
      const response = await axiosPost(url, reqBody);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

export const createProduct = createAsyncThunk(
  "product/create",
  async (reqBody: any, { rejectWithValue }) => {
    const { axiosPost } = useCustomAxios();
    const url = `${API_ENDPOINTS.createProduct}`;
    try {
      const response = await axiosPost(url, reqBody);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

export const updateProduct = createAsyncThunk(
  "product/update",
  async (reqBody: any, { rejectWithValue }) => {
    const { axiosPost } = useCustomAxios();
    const url = `${API_ENDPOINTS.updateProduct}`;
    try {
      const response = await axiosPost(url, reqBody);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

/**
 * Whether this organisation runs a curated product master. When it does, every order line has
 * to resolve to a catalogue product before the order can be placed - the server enforces that
 * regardless, this just lets the UI say so before the buyer submits.
 */
export const getCatalogueStatus = createAsyncThunk(
  "product/catalogueStatus",
  async (_arg, { rejectWithValue }) => {
    const { axiosGet } = useCustomAxios();
    try {
      const response = await axiosGet(API_ENDPOINTS.getCatalogueStatus);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message);
    }
  }
);
